import { useEffect, useMemo, useState } from "react";
import { Expedition } from "../types";

export const useBoostPercentage = (
	expedition: Expedition,
	employeesCount: number
) => {
	const [firstProgressBarWidth, setFirstProgressBarWidth] = useState(0);
	const [secondProgressBarWidth, setSecondProgressBarWidth] = useState(0);

	const progress = useMemo(() => {
		const percentage =
			parseFloat(
				(
					expedition?.user_metadata?.all_charges /
					expedition?.required_limit_for_bonus
				).toFixed(2)
			) * 2;

		if (isNaN(percentage)) {
			return 0;
		}

		return percentage;
	}, [
		expedition?.user_metadata?.all_charges,
		expedition?.required_limit_for_bonus,
		employeesCount,
	]);

	useEffect(() => {
		if (progress <= 1) {
			setFirstProgressBarWidth(progress * 100);
			setSecondProgressBarWidth(0);
		} else {
			setFirstProgressBarWidth(100);
			setSecondProgressBarWidth((progress - 1) * 100);
		}
	}, [progress]);

	return { firstProgressBarWidth, secondProgressBarWidth };
};
